module.exports = __webpack_public_path__ + "img/4.cf6b9d0a.jpg";